import { useMutation } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useCreateFlowConfiguration() {
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationFn: (data) => {
      return axiosPrivate({
        method: "POST",
        url: "Schedule/Fds/FlowConfiguration",
        data,
      });
    },
  });
}

export default useCreateFlowConfiguration;
